import './App.css';
import { useEffect } from 'react';
import ReactGA from "react-ga4";

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certs from './components/Certs';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { TRACKING_ID } from "./data/tracking";

function App() {
  useEffect(() => {
    document.title = 'Syam R S | Staff Cloud Platform Engineer & Architect';
    if (TRACKING_ID && TRACKING_ID !== "") {
      ReactGA.initialize(TRACKING_ID);
    }
  }, []);

  return (
    <div className="min-h-screen bg-dark-500 text-slate-100 selection:bg-teal-500/30 selection:text-teal-200 antialiased overflow-x-hidden w-full">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 overflow-x-hidden">
        <Hero />
        <Experience />
        <Projects />
        <Skills />
        <Certs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
